export default __webpack_public_path__ + "static/media/gallery_17.cac34d05.jpg";